define(function(require) {
    /**
     * static inclues
     *
     */
    var $ = require('jquery');
    require("../lib/stickyfill.js");
    




    /**
     * private functions
     *
     */
    var thisObject = this;


    $('#header, #left').Stickyfill();





    var last_known_scroll_position = 0;
    var ticking = false;
    var sidebar_pos = 180;
    var sidebar_sel = $('.ie #left, .edge #left');

    function doSomething(scroll_pos) {
      // do something with the scroll position
      // console.log(scroll_pos);
      if ( scroll_pos > sidebar_pos ) {
        sidebar_sel.addClass('sticky-fixed').removeClass('sticky-scroll')
      } else {
        sidebar_sel.removeClass('sticky-fixed').addClass('sticky-scroll')
      }
    }

    function getPosition(){
        last_known_scroll_position = $(window).scrollTop();
        if (!ticking) {
            window.requestAnimationFrame(function() {
              doSomething(last_known_scroll_position);
              ticking = false;
            });
          }
          ticking = true;
    }

    window.addEventListener('scroll', function(e) {
      getPosition();
    });

    /* init */
    getPosition();
});


/*****************
 ** WEBPACK FOOTER
 ** ./chunk/sticky.js
 ** module id = 6
 ** module chunks = 0
 **/